import React, { useMemo } from 'react';
import { TRIAL_DAYS } from 'utils/constants';

export const formatPrice = (price) => {
    if (!price || !price.format) {
        return price?.amount || '';
    }
    return price.format.replace('#AMOUNT#', price.amount);
};

const PlanPrice = ({ prices, interval = 'month' }) => {
    const sale = useMemo(() => {
        if (!prices || !prices.sale) {
            return null;
        }

        const amount = prices?.sale?.amount;

        if (!amount || amount === prices?.default?.amount) {
            return null;
        }

        return prices.sale;
    }, [prices]);

    if (!prices) {
        return <p>Loading...</p>;
    }
    
    return (
        <>
            <p className={sale && 'line-through'}>
                {TRIAL_DAYS > 0 && `${TRIAL_DAYS}-day free trial then `}
                {formatPrice(prices?.default)}/{interval}
            </p>

            {sale &&
                <p>
                    {TRIAL_DAYS > 0 && `${TRIAL_DAYS}-day free trial then `}
                    {formatPrice(sale)}/{interval}
                </p>
            }
        </>
    );
}

export default PlanPrice;
